<template>
  <td
    class="attachment-cell"
    :class="{
        'selected-cell': isSelect,
        'attachment-cell-hover': editable
      }"
    @click="handleFocus"
    @dragover.prevent="dragover($event)"
  >
    <img
      v-if="loading"
      src="/images/loading-spinner.gif"
      class="loading-spinner"
    >
    <img
      src="/images/Upload-Attachment.png"
      class="upload-icon"
      v-on:click="clickAttachment()"
      v-if="!element.url"
    >
    <textarea
      v-if="!element.url"
      @input="handleInput"
      @paste="handlePaste"
      v-model="form.value"
      @focus="handleFocus"
      @keydown.enter="handleEnter"
      :class="{'selected-cell': isSelect}"
      ref="cell"
      :disabled="!editable"
    >
    </textarea>
    <div
      class="flex-center"
    >
      <div @click="$emit('previewImage')">
        <img
          class="file-img"
          :src="element.type == 'image' ? element.url : '/images/Notes.svg'"
          alt=""
          v-if="element.url"
          @dragstart="dragStarted"
          @dragend="dragEnded"
        />
      </div>
      <div style="width:20px" v-if="element.url">
        <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMThweCIgaGVpZ2h0PSI1cHgiIHZpZXdCb3g9IjAgMCAxOCA1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgNjAgKDEwMTAxMCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+MzY0NDcwNzUtQ0I4OS00NkU2LTgwMzYtNDlFNjFDMTg0MTZDPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxnIGlkPSJQcmljaW5nIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iUHJpY2luZy1TaGVldC1UZW1wbGF0ZS0tLUNvbHVtbi1Ecm9wZG93bi13Ly1IaWRkZW4tQ29sdW1uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTcxLjAwMDAwMCwgLTIyMi4wMDAwMDApIiBmaWxsPSIjRDhEOEQ4Ij4KICAgICAgICAgICAgPGcgaWQ9IlByaWNpbmctU2hlZXQtQ29udGVudCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDE1OS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik05NzMuNTcxNDI5LDYzIEM5NzQuOTkxNTg5LDYzIDk3Ni4xNDI4NTcsNjQuMTE5Mjg4MSA5NzYuMTQyODU3LDY1LjUgQzk3Ni4xNDI4NTcsNjYuODgwNzExOSA5NzQuOTkxNTg5LDY4IDk3My41NzE0MjksNjggQzk3Mi4xNTEyNjgsNjggOTcxLDY2Ljg4MDcxMTkgOTcxLDY1LjUgQzk3MSw2NC4xMTkyODgxIDk3Mi4xNTEyNjgsNjMgOTczLjU3MTQyOSw2MyBaIE05ODAsNjMgQzk4MS40MjAxNjEsNjMgOTgyLjU3MTQyOSw2NC4xMTkyODgxIDk4Mi41NzE0MjksNjUuNSBDOTgyLjU3MTQyOSw2Ni44ODA3MTE5IDk4MS40MjAxNjEsNjggOTgwLDY4IEM5NzguNTc5ODM5LDY4IDk3Ny40Mjg1NzEsNjYuODgwNzExOSA5NzcuNDI4NTcxLDY1LjUgQzk3Ny40Mjg1NzEsNjQuMTE5Mjg4MSA5NzguNTc5ODM5LDYzIDk4MCw2MyBaIE05ODYuNDI4NTcxLDYzIEM5ODcuODQ4NzMyLDYzIDk4OSw2NC4xMTkyODgxIDk4OSw2NS41IEM5ODksNjYuODgwNzExOSA5ODcuODQ4NzMyLDY4IDk4Ni40Mjg1NzEsNjggQzk4NS4wMDg0MTEsNjggOTgzLjg1NzE0Myw2Ni44ODA3MTE5IDk4My44NTcxNDMsNjUuNSBDOTgzLjg1NzE0Myw2NC4xMTkyODgxIDk4NS4wMDg0MTEsNjMgOTg2LjQyODU3MSw2MyBaIiBpZD0iTW9yZS1JY29uLShEaXNwbGF5LW9uLUhvdmVyKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTgwLjAwMDAwMCwgNjUuNTAwMDAwKSByb3RhdGUoLTM2MC4wMDAwMDApIHRyYW5zbGF0ZSgtOTgwLjAwMDAwMCwgLTY1LjUwMDAwMCkgIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="
              class="delete-attachment file-img"
              @click="clickMore()"
              @contextmenu="deleteAttachment()">
      </div>
      <div
        class="box component-menu project-menu attachment-menu mini-menu df fdc jcc"
        tabindex="1"
        @blur="openMenu=false"
        v-if="openMenu"
        ref="menucontent"
        :focus="true"
      >
        <span @click="removeAttachment()">
          <p>
            <img src="/images/mini-menu-icons/Delete-Icon.png" class="always-show" alt="">
            Delete
          </p>
        </span>
      </div>
    </div>
    <input
      @change="uploadContinue($event)"
      type="file"
      ref="fileInput"
      class="file-input"
    />
  </td>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  data () {
    return {
      isSelect: false,
      loading: false,
      form: {
        value: ''
      },
      openMenu: false
    };
  },
  name: 'PricingSheetAttachmentCell',
  props: {
    element: {
      required: true
    },
    column: {
      required: true
    },
    moduleKey: {
      type: Number,
      required: true
    },
    comKey: {
      type: Number,
      required: true
    },
    cellKey: {
      required: true
    },
    prefix: {
      type: String,
      required: true
    }
  },

  methods: {
    dragStarted() {
      if (!this.editable) {
        return
      }
      this.$emit('dragStartAttachment', this.element.url)
    },
    dragEnded() {
      if (!this.editable) {
        return
      }
      this.$emit('dragEndAttachment', this.cellInf)
    },
    dragover() {
      if (!this.editable) {
        return
      }
      this.$emit('dragOverAttachment',this.cellInf)
    },
    clickMore() {
      this.openMenu = !this.openMenu;
      this.scrollTopBeforePreview = document.documentElement.scrollTop || document.body.scrollTop;
      setTimeout(() => {
        window.scrollTo(0, this.scrollTopBeforePreview);
      }, 10);
    },
    handleEnter() {
      if (!this.editable) {
        return
      }
      this.$refs['fileInput'].click()
    },
    async handlePaste(e) {
      if (!this.editable) {
        return
      }
      const items = e.clipboardData.items
      if (!items || !items.length) {
        return
      }
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") == -1) continue;
        const blob = items[i].getAsFile();
        this.loading = true
        await this.$store.dispatch('uploadAttachmentfile', {
          projectid: this.$route.params.projectid,
          module: this.moduleKey,
          component: this.comKey,
          file: blob
        })
        this.loading = false
      }
    },
    handleInput(e) {
      e.preventDefault();
      this.form.value = ''
    },
    handleFocus() {
      if (!this.isSelect) {
        this.$store.dispatch('updateSelectedCell', this.cellInf)
      }
    },
    clickAttachment () {
      if (!this.editable) {
        return
      }
      this.$refs['fileInput'].click()
    },
    async removeAttachment() {
      if (this.openMenu) {
        this.loading = true
        this.openMenu = false
        await this.$store.dispatch('removeAttachmentfile', {
          projectid: this.$route.params.projectid,
          module: this.moduleKey,
          component: this.comKey
        })
        this.loading = false
      }
    },
    async uploadContinue(e) {
      const fileList = e.target.files
      if (fileList[0]) {
        this.loading = true
        await this.$store.dispatch('uploadAttachmentfile', {
          projectid: this.$route.params.projectid,
          module: this.moduleKey,
          component: this.comKey,
          file: fileList[0]
        })
        this.loading = false
      }
    },
    editCell() {},
    selectCell() {}
  },
  computed: {
    ...mapGetters(['selectedCell', 'editingCell', 'currentProjectModules', 'userRole']),
    cellInf() {
      return {
        moduleKey: this.moduleKey,
        comKey: this.comKey,
        cellKey: this.cellKey,
        prefix: this.prefix
      }
    },
    editable() {
      return ['admin', 'collaborator', 'vendor'].includes(this.userRole)
    }
  },
  watch: {
    selectedCell(data) {
      if (!this.editable) {
        return
      }
      this.isSelect =
        Object.keys(this.cellInf).every(key => this.cellInf[key] === data[key])
      if (!this.isSelect) {
        this.isEdit = false
        this.openMenu = false
      }
    }
  },
  created () {},
  mounted() {}
}
</script>
<style scoped lang="scss">
.attachment-cell {
  word-break: break-word;
  text-align: center;
  textarea {
    width: 100%;
    height: 100%;
    border: none;
    color: transparent;
    font-size: 16px;
    background: transparent;
    display: block;
    resize:none;
    position: absolute;
    margin: 5px;
    top: 0px;
  }
  .upload-icon {
    z-index: 999;
    position: absolute;
    top: 15px;
  }
  & > .upload-icon {
    display: none;
  }
  // &:hover {
  //   .upload-icon {
  //     display: inline !important;
  //   }
  // }
  .loading-spinner {
    height: 40px;
    width: 40px;
    display: block !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .file-input {
    display: none;
  }
  .file-img {
    display: inline !important;
    height: 40px;
    width: 40px;
    border-radius: 4px;
    object-fit: contain;
    object-position: center;
    cursor: pointer;
  }
  .delete-attachment {
    display: none !important;
  }
  // &:hover {
  //   .delete-attachment {
  //     display: block !important;
  //     padding-left: 6px;width:18px;
  //   }
  // }
  .hide-menu {
    display: none;
    opacity: 0;
    span {
      cursor: none;
    }
  }
}

.attachment-cell-hover:hover {
  .delete-attachment {
    display: block !important;
    padding-left: 6px;width:18px;
  }
  .upload-icon {
    display: inline !important;
  }

}
</style>
